import '../../App.css'
import React, { useContext, useEffect, useState } from 'react'
import Aside from '../../component/aside'
import { useNavigate } from 'react-router-dom'
import Navbar from '../../component/navbar'
import { FormJsonToShamsiDay } from '../../component/FormJsonToShamsiDay'
import Loading from '../../component/loading'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import RequestQueue from '../../api/requestQueue'
import { toast } from 'react-toastify'
import { FormJsonToShamsiTime } from '../../component/FormJsonToShamsiTime'
import { AppContextMenu } from '../../App'

function FurloughGet() {
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('furloughGet')
    }, [])
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        if (!JSON.parse(localStorage.getItem('authResult'))) {
            navigate('/login')
        }
    }, [])
    const [dataGet, setDataGet] = useState([])
    let user = JSON.parse(localStorage.getItem('authResult'))
        ? JSON.parse(localStorage.getItem('authResult'))
        : { role: '' }
    let navigate = useNavigate()

    useEffect(() => {
        getFurlough()
    }, [])

    const getFurlough = async () => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/furlough-request/other`,
            },
            resolve: (res) => {
                setLoading(false)
                setDataGet(res.data)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const handlerView = (id) => {
        navigate(`/furloughGetView/${id}`)
    }

    return (
        <>
            {loading ? <Loading /> : null}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />
                    <div className="box transaction-box w-full">
                        <div className="w-full px-4 py-8">
                            <div className="bg-white w-full rounded-xl shadow-sm  border border-gray-100">
                                {/* Header - Fixed Desktop Style */}
                                <div className="px-6 py-5 border-b rounded-xl border-gray-200 flex justify-between items-center bg-gradient-to-r from-purple-100 to-indigo-500">
                                    <h2 className="text-2xl font-semibold text-white">
                                        درخواست‌های در حال انتظار دیگران
                                    </h2>
                                </div>

                                {/* Table Container */}
                                <div className="overflow-x-auto w-full">
                                    <div
                                        className="w-full"
                                        style={{ minWidth: '100%' }}
                                    >
                                        <table className="w-full divide-y divide-gray-200">
                                            {/* Table Header */}
                                            <thead className="bg-gray-50">
                                                <tr>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        نام و نام‌خانوادگی
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        نوع مرخصی
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        تاریخ مرخصی
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        ساعت مرخصی
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        تاریخ ثبت درخواست
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        وضعیت
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        مشاهده
                                                    </th>
                                                </tr>
                                            </thead>

                                            {/* Table Body */}
                                            <tbody className="bg-white divide-y divide-gray-100">
                                                {dataGet.map((d) => {
                                                    let statusItem = ''
                                                    let statusColor = ''

                                                    if (
                                                        d.status === 'pending'
                                                    ) {
                                                        statusItem = 'انتظار'
                                                        statusColor =
                                                            'bg-yellow-100 text-yellow-800'
                                                    } else if (
                                                        d.status === 'confirm'
                                                    ) {
                                                        statusItem = 'تایید'
                                                        statusColor =
                                                            'bg-green-100 text-green-800'
                                                    } else if (
                                                        d.status === 'reject'
                                                    ) {
                                                        statusItem = 'رد'
                                                        statusColor =
                                                            'bg-red-100 text-red-800'
                                                    }

                                                    return (
                                                        <tr
                                                            key={d.id}
                                                            className="group transition-all duration-300 hover:bg-gradient-to-r hover:to-indigo-100 hover:via-white hover:from-purple-100"
                                                        >
                                                            <td className="px-6 py-4 whitespace-nowrap text-center">
                                                                <div className="text-sm text-gray-900">
                                                                    {
                                                                        d.user
                                                                            .full_name
                                                                    }
                                                                </div>
                                                            </td>
                                                            <td className="px-6 py-4 whitespace-nowrap text-center">
                                                                <div className="text-sm text-gray-900">
                                                                    {d.type_furlough ===
                                                                    'daily'
                                                                        ? 'روزانه'
                                                                        : ''}
                                                                    {d.type_furlough ===
                                                                    'hourly'
                                                                        ? 'ساعتی'
                                                                        : ''}
                                                                </div>
                                                            </td>
                                                            <td className="px-6 py-4 whitespace-nowrap text-center">
                                                                <div className="text-sm text-gray-900">
                                                                    {FormJsonToShamsiDay(
                                                                        d.start_date
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td className="px-6 py-4 whitespace-nowrap text-center">
                                                                <div className="text-sm text-gray-900">
                                                                    {d.typeFurlough ===
                                                                    'hourly'
                                                                        ? `${FormJsonToShamsiTime(d.start_date)} تا ${FormJsonToShamsiTime(d.end_date)}`
                                                                        : '-'}
                                                                </div>
                                                            </td>
                                                            <td className="px-6 py-4 whitespace-nowrap text-center">
                                                                <div className="text-sm text-gray-900">
                                                                    {FormJsonToShamsiDay(
                                                                        d.created_at
                                                                    )}
                                                                    {'، '}
                                                                    {FormJsonToShamsiTime(
                                                                        d.created_at
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td className="px-6 py-4 whitespace-nowrap text-center">
                                                                <span
                                                                    className={`px-2 py-1 rounded-full text-xs font-medium ${statusColor}`}
                                                                >
                                                                    {statusItem}
                                                                </span>
                                                            </td>
                                                            <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                                                                <div className="flex justify-center">
                                                                    <button
                                                                        className="text-indigo-600 hover:text-indigo-800 bg-indigo-50 hover:bg-indigo-100 px-3 py-1.5 rounded-lg transition-colors duration-200"
                                                                        onClick={() =>
                                                                            handlerView(
                                                                                d.id
                                                                            )
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon
                                                                            icon={
                                                                                faEye
                                                                            }
                                                                            className="ml-2"
                                                                        />
                                                                        مشاهده
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default FurloughGet
